import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, inject } from '@angular/core'
import { Article, removeAllArticles, updateSearchParameters } from '../../../state'
import { PaginatedComponentBase } from '../paginated/paginated-component-base'
import { Dictionary, SearchOption, SearchOptionGroup, ExportColumnGroup, ExportColumn, isSearchCheckboxOption } from '../filtering-search-component-base/filtering-search-types'
import { FormBuilder } from '@angular/forms'
import { InputDialogComponent, StepState } from '../input-dialog/input-dialog.component'
import { Subscription, take } from 'rxjs'
import { shadesOfBlue, shadesOfGreen, shadesOfMoave, shadesOfPurple, shadesOfTeal, shadesOfYellow } from '../../colours'
import { SavedSearchService } from 'src/app/services/saved-search.service'
import { industryCheckbox } from '../filtering-search-component-base/filtering-search-common-definitions'
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap'
import { User } from 'src/app/state/user.model'
import { selectUser } from 'src/app/state/user.reducer'

@Component({
    template: '',
    standalone: true
})

export class PaginatedTableCommon<TTItem extends Article> extends PaginatedComponentBase<TTItem> implements OnInit, AfterViewInit, OnDestroy {
    private formBuilder = inject(FormBuilder)
    private savedSearchService = inject(SavedSearchService)

    @ViewChild('exportExcelDialog') set downloadComponent(c: InputDialogComponent) {
        setTimeout(() => {
            if (this.excelExportDialogComponent === null) {
                this.excelExportDialog = c
            }
        }, 0)
    }

    public excelExportDialog: InputDialogComponent | undefined
    public excelExportDialogComponent
    public excelExportRowChooser

    static DefaultExportButton = '<i-bs [name]="iconNames.FileEarmarkExcel" (click)="startDownload()" class="bi me-2"></i-bs> Export'

    public columnChooserIsVisible = false
    public searchResultsColumnDefinition: Dictionary<SearchOption> = {}

    public downloadsNotAllowed: boolean = false


    public exportColumnsToChoose: ExportColumnGroup[] = []
    public selectedArticleIDs: string[] = []
    public exportChosenSomeColumns: boolean = true
    public exportProgress: number = 0
    public exportProgressMessage: string = ''
    public exportDownloadURL: string = ''
    public exportPerDownloadLimit = 1000000
    public exportPerDownloadLimitByRow = false

    public exportButton: string = PaginatedTableCommon.DefaultExportButton

    public exportHelpForm = this.formBuilder.group({
        message: '',
    })

    public exportHelpFormState = 'waiting'

    public printableSections: [string, string][]
    public printableSectionSelections: boolean[]
    public noSectionsSelected = false

    public showShareByEmail = true
    public showPrint = true
    public showDownloads = true
    public showFilter = true

    //public loading$

    protected routerState

    public chartColours: { [key: string]: string } = {}

    private followOptions = []
    public followColumn = ''
    public followedArticles: Dictionary<any> = {}

    private user$:Subscription

    constructor() {
        super()
        this.user$ = this.store.select(selectUser).subscribe( (user:User|null ) => {
            if (user) {
                this.followedArticles = {}
                for (const alerts of Object.values(user!.searches)) {
                    for (const alert of alerts) {
                        if (alert.parameters.id) {
                            this.followedArticles[alert.parameters.id] = alert
                        }
                    }
                }
            }
        })
        this.routerState = this.router.getCurrentNavigation()?.extras.state

        this.exportPerDownloadLimitByRow = this.route.snapshot.data['exportPerDownloadLimitByRow'] ?? false
        this.followOptions = this.route.snapshot.data['followOptions']
        this.followColumn = this.route.snapshot.data['followColumn'] ?? ''
        this.printableSections = this.route.snapshot.data['sections']
        this.printableSectionSelections = Array(this.printableSections.length).fill(false)
        this.checkASectionIsSelected = this.checkASectionIsSelected.bind(this)

        const colours = [
            ...shadesOfBlue,
            ...shadesOfGreen,
            ...shadesOfTeal,
            ...shadesOfPurple,
            ...shadesOfMoave,
            ...shadesOfYellow,

            ...shadesOfBlue,
            ...shadesOfGreen,
            ...shadesOfTeal,
            ...shadesOfPurple,
            ...shadesOfMoave,
            ...shadesOfYellow,

            ...shadesOfBlue,
            ...shadesOfGreen,
            ...shadesOfTeal,
            ...shadesOfPurple,
            ...shadesOfMoave,
            ...shadesOfYellow,

        ]
        let index = 0
        for (let cbox of industryCheckbox.checkboxes) {
            this.chartColours[cbox.name] = colours[index]
            index++
        }
        for (let cbox of [
            {
                name: 'Advisor',
                value: '6',
            },
            {
                name: 'Debtor',
                value: '1',
            },
            {
                name: 'Creditor/Party in Interest',
                value: '11_21_26_56',
            },
            {
                name: 'Group Member',
                value: '51',
            },
            {
                name: 'Statutory',
                value: '31',
            },
        ]) {
            this.chartColours[cbox.name] = colours[index]
            index++
        }

        this.excelExportDialogComponent = this.route.snapshot.data['excelExportDialogComponent']
        this.excelExportRowChooser = this.route.snapshot.data['excelExportRowChooser'] ?? false

        this.showShareByEmail = this.route.snapshot.data['showShareByEmail'] ?? true
        this.showPrint = this.route.snapshot.data['showPrint'] ?? true
        this.showDownloads = this.route.snapshot.data['showDownloads'] ?? true
        this.showFilter = this.route.snapshot.data['showFilter'] ?? true
    }

    override ngOnInit(): void {
        super.ngOnInit()
        this.searchOptionGroups.forEach(optionGroup => {
            optionGroup.options.forEach(option => {
                this.searchResultsColumnDefinition[option.id] = option
            })
        })
    }

    override ngAfterViewInit(): void {
        super.ngAfterViewInit()
        const queryParams = this.route.snapshot.queryParamMap

        if (queryParams.has('download')) {
            this.routerState = this.routerState ?? {}
            this.routerState['download'] = this.routerState['download'] ?? {}
            this.routerState['download']['tableColumns'] = queryParams.get('download')?.split(',')
        }
        if (queryParams.has('rows')) {
            this.routerState!['download']['rows'] = queryParams.get('rows')
        }

        if (this.routerState?.['download']) {
            this.startDownload(this.routerState['download']['tableColumns'])
        }
    }

    override ngOnDestroy(): void {
        this.user$.unsubscribe()
    }

    override cancelCurrentAction() {
        super.cancelCurrentAction()
        this.printableSectionSelections = Array(this.printableSections.length).fill(false)
    }

    override finishAction(type: string) {
        super.finishAction(type)
        if (this.selectedArticleCount > 0) {
            if (type === 'printer' && this.printDialogComponent) {
                this.printDialogComponent.showModal(this.selectedArticles)
            } else if (type == 'download') {
                this.startDownload([], null, Object.keys(this.selectedArticles))
                this.cancelCurrentAction()
            }
        }
    }

    checkASectionIsSelected(): boolean {
        if (this.printableSections.length == 0) {
            return true
        }
        const areThereSelectedSections = this.printableSectionSelections.reduce(
            (selected: boolean, option: boolean) => selected || option,
            false
        )
        this.noSectionsSelected = !areThereSelectedSections
        return areThereSelectedSections

    }

    printArticlesStage(returned: StepState) {
        if (returned.step === 2) {
            let sectionIds = []
            for (let i = 0; i < this.printableSections.length; i++) {
                if (this.printableSectionSelections[i]) {
                    sectionIds.push(this.printableSections[i][0])
                }
            }
            const url = `/print/${this.contentSet}?ids=${Object.keys(this.selectedArticles).join(',')}&sections=${sectionIds.join(',')}`
            window.open(url, "_blank")
            this.cancelCurrentAction()
        }
    }

    allSelected(options: any[]): boolean {
        const selectedCount = options.filter((option) => option.selected).length
        return selectedCount > 0 && options.length === selectedCount
    }
    indeterminateSelected(options: any[]): boolean {
        const selectedCount = options.filter((option) => option.selected).length
        return selectedCount > 0 && selectedCount < options.length
    }

    checkColumn(group: SearchOptionGroup, event: any) {
        group.options = group.options.map(option => {
            option.tableColumn!.visible = event.target.checked
            return option
        })
    }

    allVisibleSelected(options: any[]): boolean {
        const selectedCount = options.filter((option) => option.tableColumn.visible).length
        return selectedCount > 0 && options.length === selectedCount
    }
    indeterminateVisibleSelected(options: any[]): boolean {
        const selectedCount = options.filter((option) => option.tableColumn.visible).length
        return selectedCount > 0 && selectedCount < options.length
    }

    toggleColumnChooser() {
        this.columnChooserIsVisible = !this.columnChooserIsVisible
    }

    optionGroupTableColumnVisible(optionGroup: SearchOptionGroup) {
        return optionGroup.visible && optionGroup.options.filter((option) => !option.tableColumn?.alwaysHidden).length > 0
    }

    toggleOrder(search: any, option: SearchOption) {
        let direction = 'asc'
        if (search.order.column === option.id) {
            direction = search.order!.direction === 'asc' ? 'desc' : 'asc'
        } else {
            if (option.id.toLowerCase().includes('date') || option.display?.includes('number')) {
                direction = 'desc'
            } else {
                const columnDefinition = this.calculateColumnsToShow(this.searchOptionGroups).find(col => col.id === option.id)
                if (columnDefinition && (columnDefinition.display === 'date' || columnDefinition.display === 'number')) {
                    direction = 'desc'
                }
            }
        }
        this.store.dispatch(removeAllArticles())
        this.store.dispatch(updateSearchParameters({
            ...search,
            area: this.contentSet,
            order: {
                ...search.order,
                column: option.id,
                direction
            }
        }))
    }

    checkForVisibleIfPresent(visible: boolean, option: SearchOption, searchValue: any): boolean {
        if (option?.tableColumn?.visibleIfPresent) {
            return searchValue != null && searchValue.parameters[option.id]
        }
        return visible // (option?.tableColumn?.visibleIfPresent ?? false) && article != null && article.extras[option.id]
    }

    checkForVisibleIfOptionGroupFilterEngaged(option: SearchOption, optionGroup: SearchOptionGroup): boolean {
        return (option?.tableColumn?.visibleIfOptionGroupFilterEngaged || false) && optionGroup.options.some(o => o.selected) // && this.searchResults.length > 0
    }

    calculateColumnsToShow(searchOptionGroups: SearchOptionGroup[], searchValue: any | null = null) : SearchOption[] {
        let fixedColumnsStart: SearchOption[] = []
        let fixedColumnsEnd: SearchOption[] = []
        let otherColumns: SearchOption[] = []
        searchOptionGroups.forEach(optionGroup => {
            optionGroup.options.forEach(option => {
                if (option.tableColumn && !option.tableColumn.alwaysHidden && (this.checkForVisibleIfPresent(option.tableColumn.visible ?? false, option, searchValue) || option.tableColumn.locked  || this.checkForVisibleIfOptionGroupFilterEngaged(option, optionGroup))) {
                    if (option.tableColumn.runningOrder) {
                        if (option.tableColumn.runningOrder < 0) {
                            fixedColumnsEnd[-option.tableColumn.runningOrder] = option
                        } else {
                            fixedColumnsStart[option.tableColumn.runningOrder] = option
                        }
                    } else {
                        otherColumns.push(option)
                    }
                }
            })
        })
        let result = Object.values(fixedColumnsStart).concat(otherColumns).concat(Object.values(fixedColumnsEnd))
        return result
    }

    getExportMultipler(): number {
        let multiplier = this.getExportColumns().length
        if (this.exportPerDownloadLimitByRow) {
            multiplier = 1
        }
        return multiplier
    }

    showExportButtonAndMessages() {
        if (this.downloadsNotAllowed) {
            this.exportButton = ''
        } else {
            let total = 0
            this.listing$.pipe(take(1)).subscribe(
                listing => {
                    total = listing.total
                }
            )
            if (total * this.getExportMultipler() > this.exportPerDownloadLimit) {
                this.exportButton = ''
            } else {
                this.exportButton = PaginatedTableCommon.DefaultExportButton
            }
        }
    }


    startDownload(tableColumns: string[] = [], popOver: NgbPopover | null = null, selectedArticleIDs: string[] = []) {
        if (popOver) {
            popOver.open()
            return
        }
        this.exportHelpFormState = ''
        this.exportColumnsToChoose = this.searchOptionGroups.map((group: SearchOptionGroup) => {
            let result: ExportColumnGroup = {
                groupName: group.groupName,
                options: []
            }
            if (group.showInDownloads) {
                result.options = group.options.reduce((filtered: ExportColumn[], option) => {
                    if (option.tableColumn !== null && (option.tableColumn!.showInDownloads)) {
                        filtered.push({
                            id: option.id,
                            name: option.name,
                            type: option.type,
                            selected: (option.tableColumn?.visible ?? false) || tableColumns.includes(option.id)
                        })
                    }
                    return filtered
                }, [])

            }
            return result
        }).filter((group) => group.options.length > 0)
        this.selectedArticleIDs = selectedArticleIDs
    }

    startDownloadChooser() {

    }

    getExportColumns(): any[][] {
        let columns: any[][] = []
        this.exportColumnsToChoose.forEach(optionGroup => {
            optionGroup.options.forEach(option => {
                if (option.selected) {
                    columns.push([option.id, option.name, option.type])
                }
            })
        })
        return columns
    }

    checkForSomeColumns(): boolean {
        this.exportChosenSomeColumns = this.exportColumnsToChoose.some((group) => {
            return group.options.some(option => option.selected)
        })
        return this.exportChosenSomeColumns
    }

    sendHelpEmail() {
        this.exportHelpFormState = 'sending'
    }

    graphClick(event: Event, option: SearchOption, value: string) {
        event.stopPropagation()
        if (isSearchCheckboxOption(option)) {
            for (let checkbox of option.checkboxes) {
                if (checkbox.name === value) {
                    value = checkbox.value ?? value
                    break
                }
            }
        }
        this.savedSearchService.loadSearch({
            parameters: {
                [option.id]: {
                    type: 'checkboxes',
                    name: option.id,
                    value: [value]
                }
            }
        })
    }

    followThisArticle(event: Event, id: number, title: string) {
        event.stopImmediatePropagation()
        this.savedSearchService.saveSearch({
            parameters: {
                area: this.contentSet,
                id: id,
                options: this.followOptions
            },
            area: this.contentSet,
            type: 'follow',
            name: 'Follow: ' + title
        })
    }

    unfollowThisArticle(event: Event, savedSearch: any) {
        event.stopImmediatePropagation()
        this.savedSearchService.deleteSearch(savedSearch)
    }
}
